import { useTranslation } from "react-i18next";

export function SourceReference({ number, compact = false }: { number: number; compact?: boolean }) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-grid shrink-0 place-items-center rounded-full bg-muted font-medium text-primary ${
        compact ? "size-5 text-[10px]" : "size-7 text-xs"
      }`}
    >
      <span className="sr-only">{t("administration.situationCard.sourceNumber", { number })}</span>
      <span aria-hidden="true">{number}</span>
    </span>
  );
}

export function SourceReferences({ numbers }: { numbers: readonly number[] }) {
  if (numbers.length === 0) return null;
  return (
    <span className="ml-1.5 inline-flex items-center gap-1 align-middle">
      {numbers.map((number) => (
        <SourceReference compact key={number} number={number} />
      ))}
    </span>
  );
}
